export default __webpack_public_path__ + "static/media/senju_tsunede.0183870e.png";